<template>
  <DataTable
    v-if="isDataLoaded"
    :value="actionData"
    sortField="dateAction"
    :sortOrder="-1"
    responsiveLayout="scroll"
  >
    <Column
      field="genreFichierActionAfficher"
      header="Onglet"
    ></Column>
    <Column
      field="referenceAction"
      header="Référence"
    ></Column>
    <Column field="intervenantAfficher" header="Intervenant"></Column>
    <Column field="typeActionAfficher" header="Action"></Column>
    <Column field="dateConsignation" header="Date de l'action" :sortable="true"></Column>
  </DataTable>
  <div v-else>
    <Skeleton/>
  </div>
  <h3>Nombre d'actions : {{ nombreActions }}</h3>
</template>

<script>
import commun from "../../../commun";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "TableActionsMandatPSU",
  emits: ["isDataLoaded"],
  data() {
    return {
      actionData: [],
      columns: null,
      isDataLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
        jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
    nombreActions() {
      return this.actionData.length;
    },
  },
  watch: {
    actionData() {
      if (this.actionData != null) {
        this.actionData.forEach((acces) => {
          acces.dateConsignation = commun.formatDateHeure(acces.dateConsignation);
        });

        this.isDataLoaded = true;
        this.$emit("isDataLoaded", this.isDataLoaded);
      }
    },
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;

    this.$store
      .dispatch("mandatPSU/obtenirHistoriqueActionsAction", {
        numeroMandat: this.$route.params.numeroMandat
      })
      .then((res) => {
        this.actionData = res.data;
      });
  },
};
</script>

<style scoped>
.p-datatable::v-deep(td){
  padding: 0.7rem !important;
}

@media print {
  .p-datatable::v-deep(td){
    padding: 1rem !important;
  }
}
</style>